import $ from 'jquery';
import * as d3 from "d3";
import { graduate_student, students_profession, students_performance } from './data/barChartData.js';

const graduate_student_graph = $(".graduate_student");
let graduateStudentLenght = graduate_student.length;

if ($('body').attr('id') == 'eixo3') {
  renderGraduateStudent();
}

function renderGraduateStudent() {
  for(var i = 0; i < graduateStudentLenght; i++) {
    graduate_student_graph.append(
      `<div class="wrapp">
        <div class="name">${graduate_student[i].info}</div>
        <div class="line">
          <div class="bakground"></div>
          <div class="percent" style="width: ${graduate_student[i].number}%"></div>
        </div>
      </div>`
    )
  }
}

//eixo 3 students_profession
var scale_students_profession = d3.scaleLinear()
  .domain([0, 63.9])
  .range([0, 40])
  
d3.select(".students_profession")
  .selectAll("div")
  .data(students_profession)
    .enter()
    .append("div")
    .attr("class", "line")
    .style("width", function(d) { return scale_students_profession(d.number) + "%"; })
    .html(function(d) {return "<p class='text'>" + d.info + "</p>" + "<p class='number'>" + d.number + " %</p>";});


//eixo 3 students_performance
var scale_students_performance = d3.scaleLinear()
  .domain([0, 63.9])
  .range([0, 40])
  
d3.select(".students_performance")
  .selectAll("div")
  .data(students_performance)
    .enter()
    .append("div")
    .attr("class", "line")
    .style("width", function(d) { return scale_students_performance(d.number) + "%"; })
    .html(function(d) {return "<p class='text'>" + d.info + "</p>" + "<p class='number'>" + d.number + " %</p>";});
